import urls from '../api_urls/brandAnalytics'
import { _post } from '@/axios/request'

// 获取宣称
export function getClaimData (params) {
  return _post(urls.GET_CLAIM_LIST, params)
}

// 获取品牌列表
export function getBrandData (params) {
  return _post(urls.GET_BRAND_LIST, params)
}

// 获取品牌下拉框
export function getBrandSelect (params) {
  return _post(urls.GET_BRAND_SELECT, params)
}

// 获取category
export function getCategoryData () {
  return _post(urls.GET_CATEGORY)
}

// 获取最热5大宣称
export function getTop5ClaimData (params) {
  return _post(urls.GET_TOP5_CLAIM, params)
}

// 获取产品分类
export function getProductCategory (params) {
  return _post(urls.GET_PRODUCT_CATEGORY, params)
}

// 获取最热门十大产品宣称类别分布
export function getCategoryClaim (params) {
  return _post(urls.GET_CATEGORY_CLAIM, params)
}

// 获取品牌零售价与市场份额
export function getDetailMarket (params) {
  return _post(urls.GET_DETAIL_MARKET, params)
}

// 获取市场份额
export function getDetailShare (params) {
  return _post(urls.GET_DETAIL_SHARE, params)
}

// 获取点击量
export function getClickData (params) {
  return _post(urls.GET_CLICK_DATA, params)
}

// 获取评论
export function getCommentData (params) {
  return _post(urls.GET_COMMENT_DATA, params)
}

// 产品年度5大宣称
export function getProductClaim (params) {
  return _post(urls.GET_PRODUCT_CLAIM, params)
}

// 获取产品三大全新发布
export function getNewProduct (params) {
  return _post(urls.GET_NEW_PRODUCT, params)
}

// 获取品牌产品年度发布分布
export function getProcductDistr (params) {
  return _post(urls.GET_PRODUCT_DISTR, params)
}

// 获取10大产品
export function getTop10Product (params) {
  return _post(urls.GET_TOP10_PRODUCT, params)
}

// 获取功能
export function getFunction () {
  return _post(urls.GET_FUNCTION, {type: 1})
}

// 获取功能——宣称
export function getFunctionClaim (params) {
  const data = {
    type: 0,
    ...params
  }
  return _post(urls.GET_FUNCTION, data)
}

// 获取成分使用趋势
export function getTrendData (params) {
  return _post(urls.GET_TREND, params)
}

// 获取年度画像
export function getAnnualData (params) {
  return _post(urls.GET_ANNUAL_DATA, params)
}

// 获取年度画像（用户）
export function getConsumerAnn (params) {
  return _post(urls.GET_CONSUMER_ANN, params)
}

// 获取集团下品牌
export function getBrandGroup (params) {
  return _post(urls.GET_BRAND_GROUP, params)
}

// 获取国家
export function getCountryData (params) {
  return _post(urls.GET_COUNTRY, params)
}

// 获取品牌下年份字典
export function getBrandYear () {
  return _post(urls.GET_BRAND_YEAR_LIST, {yearType: 0})
}

// 获取品牌定位数据
export function getPositionMap (params) {
  return _post(urls.GET_POSITION_MAP, params)
}

// 获取brand group模糊查询
export function getGroupList (params) {
  return _post(urls.GET_GROUP_lIST, params)
}

// 获取sub category
export function getSubCategory (params) {
  return _post(urls.GET_SUB_CATEGORY, params)
}

// 获取地区详情
export function getAreaDetail (params) {
  return _post(urls.GET_AREA_DETAIL, params)
}

// 获取 segment
export function getSegmentList (params) {
  return _post(urls.getSegmentList, params)
}

// 获取 brand 详情
export function getBrandDetail (params) {
  return _post(urls.GET_BRAND_DETAIL, params)
}

// 获取 导出数据数量
export function getExportCount (params) {
  return _post(urls.GET_EXPORT_COUNT, params)
}

// 获取 品牌建议
export function getBrandSuggested (params) {
  return _post(urls.GET_BRAND_SUGGESTED, params)
}

// 获取顶部信息
export function getUpdateItem (params) {
  return _post(urls.getUpdateItem, params)
}

// 获取 origin
export function getOriginList (params) {
  return _post(urls.GET_ORIGIN_LIST, params)
}

export function getAgeData (params) {
  return _post(urls.GET_AGE_DATA, params)
}

export function getRelateBasfProducts (params) {
  return _post(urls.GET_RELATED_BASF_PRODUCTS, params)
}
export function getConsumerClickData (params) {
  return _post(urls.GET_CONSUMER_CLICK_DATA, params)
}
export function getConsumerCommentData (params) {
  return _post(urls.GET_CONSUMER_COMMENT_DATA, params)
}
export function getCommentProvincesData (params) {
  return _post(urls.GET_COMMENT_PROVINCES_DATA, params)
}

// 获取国家全称
export function getCountryNamesData (params) {
  return _post(urls.GET_COUNTRY_NAMES, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/brandAnalytics.js